import { watch, type WatchSource, type WatchStopHandle } from 'vue';
import type { PrimeVueConfiguration } from 'primevue/config';

/**
 * Keeps the words PrimeVue writes itself in the app's locale. Every Dialog's, Drawer's and Toast's ✕
 * takes its accessible name from PrimeVue's own `locale.aria.close`, which knows nothing of
 * vue-i18n's locale, so it read "Close" to a reader in Spanish (ENG-10286).
 *
 * The rest of PrimeVue's locale is left as it is. The config is reactive, so a ✕ already on screen
 * follows a change of locale too.
 */
export const followAppLocale = (
  config: PrimeVueConfiguration,
  locale: WatchSource<string>,
  t: (key: string) => string
): WatchStopHandle =>
  watch(locale, () => {
    // PrimeVue's install fills `locale` from its defaults, so it is always there to write into.
    if (config.locale) {
      config.locale.aria = { ...config.locale.aria, close: t('close') };
    }
  }, { immediate: true });
